import { PREFILL_USER_DATA } from '../app-communication/actions/from-client-frontend';

export const initialState = {
  userNames: '',
  email: ''
};

export const prefillUserDataReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case PREFILL_USER_DATA:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};
